import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Message, MessageService } from 'primeng/api';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppConstants } from '../shared/app.constants';


@Injectable({
  providedIn: 'root'
})
export class ServiceBase {
  protected readonly token = sessionStorage.getItem(environment.authTokenStorageKey);
  protected apiRoot: string = environment.apiEndpoint;
  protected readonly httpAuth = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + this.token
    })
  };

  protected readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  };

  protected readonly httpOptionsText = {
    responseType: 'text',
    headers: new HttpHeaders({
      'Content-Type': 'text/plain',
      'Accept': 'text/plain'
    })
  };

  protected readonly httpNoCache = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + this.token,
      'Pragma': 'no-cache',
      'Cache-Control': 'no-store, max-age=0'
    })
  };
  protected readonly httpNoAuth = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'No-Auth': 'True'
    })
  };

  protected readonly httpNoAuthCache = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'No-Auth': 'True',
      'Pragma': 'no-cache',
    })
  };

  protected readonly httpBlob = {
    responseType: 'blob' as 'json',
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  };

  protected readonly httpFormData =  {
    headers: new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + this.token
    })
  };

  constructor(protected http: HttpClient,
    public messageService: MessageService) { }

  // Used when an error should NOT be thrown back to component, result (usually a null) when be sent to complete/next
  protected swallowError<T>(operation = 'operation', toastKey?: string, summary?: string, result?: T) {
    return this.handleError2(operation, true, toastKey, summary, result);
  }

  // Used when the error should be thrown back to component
  protected throwError<T>(operation = 'operation', toastKey?: string, summary?: string, result?: T) {
    return this.handleError2(operation, false, toastKey, summary, result);
  }

  private handleError2<T>(operation = 'operation', isSwallow: boolean, toastKey:string, summary: string, result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      this.messageService.clear();

      let detailString = error.status === 0 ? 'There is an issue contacting the NESS server.' : (error?.error?.ExceptionMessage || error?.error?.Message || error?.error);
      let errorMsgObj: Message = {
        key: toastKey,
        severity: 'error',
        summary: summary ?? 'Request "' + operation + '" to NESS server failed:',
        detail: detailString
      }
      
      // TODO: send the error to remote logging infrastructure
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${errorMsgObj.detail}`);

      if (error.status === 0) {
        AppConstants.showGlobalMsgDialog = true;
      }

      if (toastKey != null) this.messageService.add(errorMsgObj);

      if (isSwallow) // Let the app keep running by returning an empty result.
        return of(result as T);
      else
        throw error;
      
    };
  }
}
